import { render, staticRenderFns } from "./zfb.vue?vue&type=template&id=994789e2&scoped=true&"
import script from "./zfb.vue?vue&type=script&lang=js&"
export * from "./zfb.vue?vue&type=script&lang=js&"
import style0 from "./zfb.vue?vue&type=style&index=0&id=994789e2&scoped=true&lang=css&"
import style1 from "./zfb.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994789e2",
  null
  
)

export default component.exports